import { z } from "zod"

export const loginMotdSchema = z.object({
  id: z.number(),
  message: z.string(),
  textColor: z.string(),
  activeStartDate: z
    .string()
    .nullable()
    .transform((val) => (val ? new Date(val) : null)),
  activeEndDate: z
    .string()
    .nullable()
    .transform((val) => (val ? new Date(val) : null)),
  domainName: z.string(),
})
export type LoginMotd = z.infer<typeof loginMotdSchema>
